// components/SettingsListener/SettingsListener.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useWebSocket } from '../../context/WebSocketContext';
import { useDbContext } from '../../context/DbContext';
import { setSoftwareSettings } from '../../app/settingsSlice';
import { clearPrintTemplateCache } from '../../hooks/usePrintService';
import axios from 'axios';

const SettingsListener = () => {
  const socket = useWebSocket();
  const dispatch = useDispatch();
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!socket || !dbCode) return;

    const handleSettingsUpdate = async (data) => {
      // Check if the updated settings belong to current database
      if (data.dbCode === dbCode) {
        try {
          // Fetch the latest settings from server to ensure we have complete data
          const response = await axios.get(
            `${apiBaseUrl}/common/getSettings/${dbCode}`
          );
          if (response.data.success) {
            dispatch(setSoftwareSettings(response.data.data));
            //console.log('Settings updated via WebSocket',response.data.data);
          }
        } catch (error) {
          console.error('Error fetching updated settings:', error);
        }
      }
    };

    const handlePrintTemplateUpdate = (data) => {
      if (!data || !data.dbCode || data.dbCode === dbCode) {
        clearPrintTemplateCache();
        window.dispatchEvent(new CustomEvent('printTemplateUpdated', { detail: data }));
      }
    };

    // Listen for settings updates
    socket.on('settingsUpdated', handleSettingsUpdate);
    socket.on('printTemplateUpdated', handlePrintTemplateUpdate);

    // Listen for connection events
    socket.on('connect', () => {
      //console.log('WebSocket connected for settings updates');
    });

    socket.on('disconnect', () => {
      //console.log('WebSocket disconnected');
    });

    return () => { 
      socket.off('settingsUpdated', handleSettingsUpdate);
      socket.off('printTemplateUpdated', handlePrintTemplateUpdate);
      socket.off('connect');
      socket.off('disconnect');
    };
  }, [socket, dispatch, dbCode, apiBaseUrl]);

  return null; // This component doesn't render anything
};

export default SettingsListener;